import * as React from 'react';
import Svg, {Path, Defs, LinearGradient, Stop} from 'react-native-svg';

function TRialBlazerIconWeb(props) {
  return (
    <Svg width={95} height={96} viewBox="0 0 95 96" fill="none" {...props}>
      <Path
        d="M47.5 95.5C73.734 95.5 95 74.234 95 48 95 21.767 73.734.5 47.5.5 21.267.5 0 21.767 0 48c0 26.234 21.267 47.5 47.5 47.5z"
        fill="url(#paint0_linear_24876_452)"
      />
      <Path
        d="M47.5 88c22.299 0 40.375-18.076 40.375-40.375S69.799 7.25 47.5 7.25 7.125 25.326 7.125 47.625 25.201 88 47.5 88z"
        fill="#E6ECFF"
      />
      <Path
        d="M65.075 64.688h-35.5a2.912 2.912 0 00-2.912 2.912v2.975a2.912 2.912 0 002.912 2.912h35.5a2.913 2.913 0 002.912-2.912V67.6a2.913 2.913 0 00-2.912-2.912z"
        fill="url(#paint1_linear_24876_452)"
      />
      <Path
        d="M65.063 71.8h-35.5a2.923 2.923 0 01-2.913-2.912v1.687c0 1.6 1.313 2.913 2.913 2.913h35.5c1.6 0 2.912-1.313 2.912-2.913v-1.687c0 1.6-1.313 2.912-2.912 2.912z"
        fill="#60A09C"
        opacity={0.4}
      />
      <Path
        d="M41.563 63.75h-2.325c-.125 0-.225.087-.225.2v11.737c0 .338.912 1.475.912 1.475.213.325.738.325.95 0 0 0 .913-1.137.913-1.475V63.95c0-.113-.1-.2-.225-.2z"
        fill="#0052BF"
      />
      <Path
        d="M40.413 71.312h-.038c-.05 0-.087-.05-.087-.112v-1.238c0-.037.062-.162.062-.162.013-.038.05-.038.075 0 0 0 .063.125.063.162V71.2c0 .062-.038.112-.088.112h.013z"
        fill="#E7E7E7"
      />
      <Path
        d="M41.95 70.162a.165.165 0 00-.162-.162h-2.8a.165.165 0 00-.163.162V73.2c0 .087.075.162.163.162a.165.165 0 00.162-.162v-2.875h2.438V73.2c0 .087.075.162.162.162a.165.165 0 00.163-.162l.037-3.05v.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M41.85 73.237h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425zM41.85 68.063h-2.912a.425.425 0 00-.425.424v.25c0 .235.19.425.425.425h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.424z"
        fill="#E7E7E7"
      />
      <Path
        d="M52.063 64.088h2.325c.125 0 .224.087.224.187v11.45c0 .338-.912 1.438-.912 1.438-.213.312-.738.312-.95 0 0 0-.913-1.1-.913-1.438v-11.45c0-.1.1-.187.225-.187z"
        fill="#0052BF"
      />
      <Path
        d="M53.213 71.313h.037c.05 0 .088-.05.088-.112v-1.238c0-.037-.063-.162-.063-.162-.012-.038-.05-.038-.075 0 0 0-.062.125-.062.162v1.238c0 .062.037.112.087.112h-.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M51.663 70.162c0-.087.075-.162.162-.162h2.8c.087 0 .163.075.163.162V73.2a.165.165 0 01-.163.162.165.165 0 01-.163-.162v-2.875h-2.437V73.2a.165.165 0 01-.163.162.165.165 0 01-.162-.162l-.038-3.05v.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M51.763 74.338h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425zM51.763 69.263h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425h-2.912a.425.425 0 00-.425.425v.25c0 .234.19.425.425.425z"
        fill="#E7E7E7"
      />
      <Path
        d="M47.013 18.513c-1.863 0-3.388 2.737-3.388 6.125h.75c0-2.988 1.175-5.425 2.625-5.425s2.625 2.425 2.625 5.425h.75c0-3.388-1.513-6.125-3.375-6.125h.013z"
        fill="#003780"
      />
      <Path
        d="M40.716 16.904l-1.816.41a1.712 1.712 0 00-1.295 2.047l1.528 6.78a1.713 1.713 0 002.047 1.294l1.817-.41a1.712 1.712 0 001.294-2.046l-1.527-6.78a1.712 1.712 0 00-2.048-1.295zM50.983 27.02l1.817.41a1.713 1.713 0 002.047-1.295l1.528-6.78a1.713 1.713 0 00-1.294-2.047l-1.817-.41a1.713 1.713 0 00-2.047 1.295l-1.528 6.78a1.713 1.713 0 001.294 2.047z"
        fill="#003780"
      />
      <Path
        d="M62.088 62.625h-1.875a2.982 2.982 0 01-2.975-2.975v-9.2c0-.638.512-1.15 1.15-1.15h5.537c.638 0 1.15.513 1.15 1.15v9.2a2.982 2.982 0 01-2.975 2.975h-.012z"
        fill="url(#paint2_linear_24876_452)"
      />
      <Path
        d="M60.313 47.926h2.5a2.657 2.657 0 012.662 2.662v1.163a1.03 1.03 0 01-1.025 1.025h-5.775a1.03 1.03 0 01-1.025-1.025v-1.163a2.657 2.657 0 012.663-2.662z"
        fill="#0052BF"
      />
      <Path
        d="M30.2 49.263h5.537c.638 0 1.15.512 1.15 1.15v9.2a2.982 2.982 0 01-2.974 2.975h-1.875a2.982 2.982 0 01-2.975-2.975v-9.2c0-.638.512-1.15 1.15-1.15H30.2z"
        fill="url(#paint3_linear_24876_452)"
      />
      <Path
        d="M35.45 52.738h-5.775a1.03 1.03 0 01-1.025-1.025v-1.162a2.657 2.657 0 012.663-2.663h2.5a2.657 2.657 0 012.662 2.663v1.162a1.03 1.03 0 01-1.025 1.025z"
        fill="#0052BF"
      />
      <Path
        d="M43.612 25.788H50.4c5.938 0 10.75 4.813 10.75 10.75v24.513c0 2.1-1.7 3.8-3.8 3.8H36.662c-2.1 0-3.8-1.7-3.8-3.8V36.538c0-5.937 4.813-10.75 10.75-10.75z"
        fill="#066DFF"
      />
      <Path
        d="M57.35 62.95H36.662a3.814 3.814 0 01-3.8-3.8v1.888c0 2.087 1.713 3.8 3.8 3.8H57.35c2.087 0 3.8-1.713 3.8-3.8V59.15c0 2.088-1.712 3.8-3.8 3.8z"
        fill="#F8A326"
        opacity={0.4}
      />
      <Path
        d="M36.65 23.1h20.738c.962 0 1.737.776 1.737 1.738v5.538a6.562 6.562 0 01-6.563 6.562H41.475a6.562 6.562 0 01-6.563-6.562v-5.538c0-.962.776-1.737 1.738-1.737z"
        fill="url(#paint4_linear_24876_452)"
      />
      <Path
        d="M57.375 23.1H36.638a1.75 1.75 0 00-1.738 1.738v.838c0-.95.788-1.738 1.738-1.738h20.737c.95 0 1.737.788 1.737 1.738v-.838a1.75 1.75 0 00-1.737-1.737z"
        fill="#BE4D27"
        opacity={0.3}
      />
      <Path
        d="M36.65 48.325h20.738c.962 0 1.737.775 1.737 1.738v8.262a6.562 6.562 0 01-6.563 6.563H41.475a6.562 6.562 0 01-6.563-6.563v-8.262c0-.963.776-1.738 1.738-1.738z"
        fill="#66A7FF"
      />
      <Path
        d="M36.463 48.325h21.1c.862 0 1.562.7 1.562 1.563v2.35a5.876 5.876 0 01-5.875 5.875H40.8a5.876 5.876 0 01-5.875-5.875v-2.35c0-.863.7-1.563 1.563-1.563h-.025z"
        fill="url(#paint5_linear_24876_452)"
      />
      <Path
        d="M52.638 39.275h-11.25c-.946 0-1.713.767-1.713 1.713v3.125c0 .946.767 1.712 1.713 1.712h11.25c.945 0 1.712-.766 1.712-1.712v-3.125c0-.946-.767-1.713-1.712-1.713z"
        fill="url(#paint6_linear_24876_452)"
      />
      <Path
        d="M48.225 29.813h-2.438c-.124 0-.237.1-.237.212v13.05c0 .387.95 1.637.95 1.637.225.363.775.363.987 0 0 0 .95-1.262.95-1.637v-13.05c0-.125-.1-.212-.237-.212h.025z"
        fill="#0052BF"
      />
      <Path
        d="M47.025 36.75h-.038c-.05 0-.087-.05-.087-.125v-1.287c0-.038.075-.175.075-.175a.04.04 0 01.075 0s.075.137.075.175v1.287c0 .063-.038.125-.087.125h-.013z"
        fill="#E7E7E7"
      />
      <Path
        d="M48.638 35.537a.179.179 0 00-.175-.175H45.55a.188.188 0 00-.175.175v3.175c0 .088.075.175.175.175a.17.17 0 00.175-.175v-3h2.538v3c0 .088.075.175.175.175a.17.17 0 00.174-.175l.038-3.175h-.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M48.55 38.75h-3.063a.438.438 0 00-.437.438v.274c0 .242.196.438.438.438h3.062a.437.437 0 00.438-.438v-.275a.437.437 0 00-.438-.437zM48.55 32.388h-3.063a.438.438 0 00-.437.437v.275c0 .242.196.438.438.438h3.062a.437.437 0 00.438-.438v-.275a.437.437 0 00-.438-.437zM47.063 41.15a.25.25 0 100-.5.25.25 0 000 .5zM47.063 42.275a.25.25 0 100-.5.25.25 0 000 .5zM47.063 43.388a.25.25 0 100-.5.25.25 0 000 .5z"
        fill="#E7E7E7"
      />
      <Path
        d="M41.8 47.95h-2.325c-.125 0-.225.1-.225.238v14.125c0 .412.913 1.775.913 1.775a.533.533 0 00.95 0s.912-1.363.912-1.775V48.188c0-.125-.1-.238-.225-.238z"
        fill="#0052BF"
      />
      <Path
        d="M40.65 58.3h-.038c-.05 0-.087-.05-.087-.112V56.95c0-.037.063-.162.063-.162.012-.038.05-.038.075 0 0 0 .062.125.062.162v1.238c0 .062-.038.112-.087.112h.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M42.2 57.15a.166.166 0 00-.163-.163h-2.8a.165.165 0 00-.162.163v3.037c0 .088.075.163.162.163a.166.166 0 00.163-.163v-2.875h2.438v2.875c0 .088.075.163.162.163a.165.165 0 00.162-.163l.038-3.05v.013z"
        fill="#E7E7E7"
      />
      <Path
        d="M42.087 60.213h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425h2.913c.234 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425zM42.087 54.125h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425h2.913c.234 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425zM42.087 51.375h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425h2.913c.234 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425z"
        fill="#E7E7E7"
      />
      <Path
        d="M52.3 47.95h2.325c.125 0 .225.1.225.238v14.125c0 .412-.912 1.775-.912 1.775a.533.533 0 01-.95 0s-.913-1.363-.913-1.775V48.188c0-.125.1-.238.225-.238z"
        fill="#0052BF"
      />
      <Path
        d="M53.45 58.3h.037c.05 0 .088-.05.088-.112V56.95c0-.037-.063-.162-.063-.162-.012-.038-.05-.038-.075 0 0 0-.062.125-.062.162v1.238c0 .062.038.112.087.112h-.012z"
        fill="#E7E7E7"
      />
      <Path
        d="M51.913 57.15c0-.088.075-.163.162-.163h2.8c.087 0 .163.075.163.163v3.037a.165.165 0 01-.163.163.165.165 0 01-.163-.163v-2.875h-2.437v2.875a.165.165 0 01-.163.163.165.165 0 01-.162-.163l-.038-3.05v.013z"
        fill="#E7E7E7"
      />
      <Path
        d="M52.013 61.325h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425h-2.912a.425.425 0 00-.425.425v.25c0 .235.19.425.425.425zM52.013 55.226h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425h-2.912a.425.425 0 00-.425.425v.25c0 .234.19.425.425.425zM52.013 52.688h2.912c.235 0 .425-.19.425-.425v-.25a.425.425 0 00-.425-.425h-2.912a.425.425 0 00-.425.425v.25c0 .234.19.425.425.425z"
        fill="#E7E7E7"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_24876_452"
          x1={0}
          y1={48}
          x2={95}
          y2={48}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_24876_452"
          x1={26.6625}
          y1={69.075}
          x2={67.975}
          y2={69.075}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_24876_452"
          x1={57.2376}
          y1={55.9625}
          x2={65.0626}
          y2={55.9625}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_24876_452"
          x1={29.0625}
          y1={55.9127}
          x2={36.8875}
          y2={55.9127}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_24876_452"
          x1={34.9}
          y1={30.0131}
          x2={59.1125}
          y2={30.0131}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_24876_452"
          x1={34.9}
          y1={53.2127}
          x2={59.1125}
          y2={53.2127}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_24876_452"
          x1={39.675}
          y1={42.5504}
          x2={54.35}
          y2={42.5504}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#066DFF" />
          <Stop offset={1} stopColor="#58C6BB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default TRialBlazerIconWeb;
